module.exports = __webpack_public_path__ + "img/basic_skinwash_set_202310.20ae70c1.jpg";